exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3DMP3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3DMP3,.GoHjA{position:relative}.GoHjA{font-size:12px;color:#888;font-weight:400;margin:15px 0}.ysz5W>span{width:100%;max-width:240px}", ""]);

// exports
exports.locals = {
	"root": "_3DMP3",
	"title": "GoHjA",
	"newsItemLayziLoad": "ysz5W"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/dealer/components/NewsAndPromotions/NewsAndPromotions.css
// module id = 2698
// module chunks = 15 17